import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  text?: string;
  text2?: string;
  text3?: string;
  text4?: string;
  text5?: string;
  text6?: string;
  text7?: string;
  text8?: string;
  text9?: string;
  text10?: string;
  text11?: string;
  text12?: string;
  text13?: string;
  text14?: string;
  text15?: string;
  text16?: string;
  text17?: string;
  text18?: string;
  text19?: string;
  text20?: string;
  text21?: string;
  text22?: string;
  text23?: string;
  text24?: string;
  text25?: string;
  text26?: string;
  text27?: string;
  text28?: string;
  text29?: string;
  text30?: string;
  text31?: string;
  text32?: string;
  text33?: string;
  text34?: string;
  text35?: string;
  text36?: string;
  text37?: string;
  text38?: string;
}
export const SouthernRegion: RouteInfo[] = [
  {
    text: 'Alhambra Chamber of Commerce',
    text2: 'Bell Gardens Chamber of Commerce',
    text3: 'Black Chamber of Orange County',
    text4: 'Brea Chamber of Commerce',
    text5: 'CA Latino Business Institute',
    text6: 'Camarillo Chamber of Commerce',
    text7: 'Cerritos Chamber of Commerce',
    text8: 'Diversity Business Forum of SABAN',
    text9: 'East Los Angeles Chamber of Commerce',
    text10: 'Greater Santa Barbara Hispanic Chamber of Commerce',
    text11: 'HBA Paso Robles',
    text12: 'Huntington Beach Chamber of Commerce',
    text13: 'Imperial Valley Hispanic Chamber of Commerce',
    text14: 'Los Angeles Area Chamber of Commerce',
    text15: 'Los Angeles Latino Chamber of Commerce',
    text16: 'Multicultural Business Alliance',
    text17: 'National Latina Businesswomen Association',
    text18: 'National Latina Businesswomen Association - Los Angeles',
    text19: 'National Latina Businesswomen Association - San Diego',
    text20: 'New Economics for Women',
    text21: 'Oceanside Chamber of Commerce',
    text22: 'Orange County Hispanic Chamber of Commerce',
    text23: 'Orange County Hispanic Chamber of Commerce Education Foundation',
    text24: 'San Diego County Hispanic Chamber of Commerce',
    text25: 'San Juan Capistrano Chamber of Commerce',
    text26: 'Santa Ana Chamber of Commerce',
    text27: 'Santa Barbara South Coast Chamber of Commerce',
    text28: 'Santa Clarita Valley Chamber of Commerce',
    text29: 'Santa Maria Valley Chamber of Commerce',
    text30: 'South Gate Chamber of Commerce',
    text31: 'Southern California Hispanic Chamber of Commerce',
    text32: 'US Latino American Chamber of Commerce',
    text33: 'US Mexico Chamber of Commerce',
    text34: 'Ventura Chamber of Commerce',
  },
];
// export const SouthernRegionAffiliates: RouteInfo[] = [
//   {
//     text: 'Santa Maria Valley Chamber of Commerce',
//     text2: 'Los Angeles Area Chamber of Commerce',
//     text3: 'National Latina Businesswomen Association',
//     text4: 'Multicultural Business Alliance',
//     text5: 'Black Chamber of Orange County',
//     text6: 'Ventura Chamber of Commerce',
//     text7: 'Camarillo Chamber of Commerce',
//     text8: 'National Latina Businesswomen Association - Los Angeles',
//     text9: 'East Los Angeles Chamber of Commerce',
//     text10: 'Bell Gardens Chamber of Commerce',
//     text11: 'South Gate Chamber of Commerce',
//     text12: 'Cerritos Chamber of Commerce',
//     text13: 'Santa Clarita Valley Chamber of Commerce',
//     text14: 'Oceanside Chamber of Commerce',
//     text15: 'National Latina Businesswomen Association - San Diego',
//     text16: 'Huntington Beach Chamber of Commerce',
//     text17: 'San Juan Capistrano Chamber of Commerce',
//     text18: 'Diversity Business Forum of SABAN',
//     text19: 'Santa Ana Chamber of Commerce',
//     text20: 'Brea Chamber of Commerce',
//     text21: 'CA Latino Business Institute',
//     text22: 'Santa Barbara South Coast Chamber of Commerce',
//     text23: 'HBA Paso Robles',
//     text24: 'Alhambra Chamber of Commerce',
//     text25: 'New Economics for Women',
//   },
// ];
export const InlandEmpireRegion: RouteInfo[] = [
  {
    text: 'Antelope Valley Hispanic Chamber of Commerce',
    text2: 'Asian Business Association Inland Empire',
    text3: 'Black Chamber of Commerce of Inland Empire',
    text4: 'Colton Chamber of Commerce',
    text5: 'Greater Coachella Valley Chamber of Commerce (Main Office)',
    text6: 'Greater Corona Hispanic Chamber of Commerce',
    text7: 'Greater Riverside Hispanic Chamber of Commerce',
    text8: 'Indian Wells Chamber of Commerce',
    text9: 'Inland Empire Regional Chambers',
    text10: 'La Camara de Comercio Hispana del Valle de Pomona',
    text11: 'Latin Chamber of Commerce Las Vegas',
    text12: 'Miracles and Dreams Foundation',
    text13: 'Moreno Valley Hispanic Chamber of Commerce',
    text14: 'National Latina Business Women Association - Inland Empire',
    text15: 'North American Pallet Association IE',
    text16: 'Ontario Hispanic Chamber of Commerce',
    text17: 'Palm Springs Chamber of Commerce',
    text18: 'Perris Valley Chamber of Commerce',
    text19: 'Pomona Chamber of Commerce',
    text20: 'Riverside County Black Chamber of Commerce',
    text21: 'Temecula Valley Chamber of Commerce',
    text22: 'The Association of Health Organization Entrepreneurs (TAHO)',
  },
];
// export const InlandEmpireRegionAffiliates: RouteInfo[] = [
//   {
//     text: 'Indian Wells Chamber of Commerce',
//     text2: 'Greater Coachella Valley Chamber of Commerce (Main Office)',
//     text3: 'Palm Springs Chamber of Commerce',
//     text4: 'Perris Valley Chamber of Commerce',
//     text5: 'Asian Business Association Inland Empire',
//     text6: 'Latin Chamber of Commerce Las Vegas',
//     text7: 'National Latina Business Women Association - Inland Empire',
//     text8: 'Inland Empire Regional Chambers',
//     text9: 'The Association of Health Organization Entrepreneurs (TAHO)',
//     text10: 'Pomona Chamber of Commerce',
//     text11: 'Colton Chamber of Commerce',
//     text12: 'North American Pallet Association IE',
//     text13: 'Black Chamber of Commerce of Inland Empire',
//     text14: 'Riverside County Black Chamber of Commerce',
//     text15: 'Miracles and Dreams Foundation',
//     text16: 'Temecula Valley Chamber of Commerce',
//   },
// ];
export const CentralRegion: RouteInfo[] = [
  {
    text: 'African American Chamber of Commerce of San Joaquin County',
    text2: 'Boys & Girls Club of North Valley ',
    text3: 'CAL Asian Chamber of Commerce',
    text4: 'California Mexican American Veterans Memorial Foundation',
    text5: 'California Urban Partnership',
    text6: 'Central California Hispanic Chamber of Commerce',
    text7: 'Central Valley Asian American CC',
    text8: 'Central Valley Hispanic Chamber of Commerce',
    text9: 'Comerciantes Unidos Stockton',
    text10: 'Elk Grove Chamber of Commerce',
    text11: 'Fresno Area Hispanic Foundation',
    text12: 'Fresno Metro Black Chamber of Commerce',
    text13: 'Greater Modesto Chamber of Commerce',
    text14: 'Greater Reedley Chamber of Commerce',
    text15: 'Greater Sacramento Vietnamese American Chamber of Commerce',
    text16: 'Greater Stockton Chamber of Commerce',
    text17: 'Hispanic Chamber of Commerce of Northern California',
    text18: 'Kern County Hispanic Chamber of Commerce',
    text19: 'Lodi Chamber of Commerce',
    text20: 'Merced County Hispanic Chamber of Commerce',
    text21: 'Merced County Indian Chamber of Commerce',
    text22: 'North State Hispanic Chamber of Commerce',
    text23: 'Oakland Latino Chamber of Commerce',
    text24: 'Ripon Chamber of Commerce',
    text25: 'Sacramento Black Chamber of Commerce',
    text26: 'Sacramento Hispanic Chamber of Commerce',
    text27: 'San Joaquin County Hispanic Chamber of Commerce',
    text28: 'Slavic American Chamber of Commerce',
    text29: 'South Modesto Businesses United',
    text30: 'The California African American CC',
    text31: 'The Northern California Peruvian CC',
    text32: 'Tracy Chamber of Commerce',
    text33: 'Tulare Kings Hispanic Chamber of Commerce',
  },
];
// export const CentralRegionAffiliates: RouteInfo[] = [
//   {
//     text: 'Boys & Girls Club of North Valley ',
//     text2: 'Greater Reedley Chamber of Commerce',
//     text3: 'Fresno Metro Black Chamber of Commerce',
//     text4: 'African American Chamber of Commerce of San Joaquin County',
//     text5: 'Greater Stockton Chamber of Commerce',
//     text6: 'Lodi Chamber of Commerce',
//     text7: 'Ripon Chamber of Commerce',
//     text8: 'California Mexican American Veterans Memorial Foundation',
//     text9: 'The California African American CC',
//     text10: 'Comerciantes Unidos Stockton',
//     text11: 'Central Valley Asian American CC',
//     text12: 'Merced County Indian Chamber of Commerce',
//     text13: 'Greater Modesto Chamber of Commerce',
//     text14: 'South Modesto Businesses United',
//     text15: 'Tracy Chamber of Commerce',
//     text16: 'Elk Grove Chamber of Commerce',
//     text17: 'The Northern California Peruvian CC',
//     text18: 'California Urban Partnership',
//     text19: 'Oakland Latino Chamber of Commerce',
//     text20: 'Slavic American Chamber of Commerce',
//     text21: 'CAL Asian Chamber of Commerce',
//     text22: 'Sacramento Black Chamber of Commerce',
//     text23: 'Greater Sacramento Vietnamese American Chamber of Commerce',
//     text24: 'Fresno Area Hispanic Foundation',
//    },
// ];

export const NorthernRegion: RouteInfo[] = [
  {
    text2: 'Bay Area Salvadoran American Chambers of Commerce',
    text3: 'Camara De Comercio Agrupación Del Norte De California',
    text4: 'Conectando Latinos ',
    text5: 'Gilroy Chamber of Commerce',
    text6: 'Greater Concord Chamber of Commerce',
    text7: 'Guatemalan American Chamber of Commerce',
    text8: 'Hispanic Chamber of Commerce of Contra Costa County',
    text9: 'Hispanic Chamber of Commerce of Marin',
    text10: 'Hispanic Chambers of Commerce San Francisco',
    text11: 'Hispanic Chamber of Commerce Silicon Valley',
    text12: 'Hispanic Chamber of Commerce Sonoma County',
    text13: 'Latin American & Caribbean Business Chamber of Commerce',
    text14: 'Latin Business Foundation of Silicon Valley',
    text15: 'Latino Committee/San Mateo Chamber',
    text16: 'Latino Tax Professionals',
    text17: 'Livermore Valley Chamber of Commerce',
    text18: 'Napa County Hispanic Chamber of Commerce',
    text19: 'Nicaraguan American Chamber of Commerce Northern California',
    text20: 'Negozee',
    text21: 'Oakland African American Chamber of Commerce',
    text22: 'Oakland Latino Chamber of Commerce',
    text23: 'San Francisco African American Chamber of Commerce',
    text24: 'San Francisco Filipino American Chamber of Commerce',
    text25: 'Silicon Valley Black Chamber of Commerce',
    text26: 'Solano Hispanic Chamber of Commerce',
  },
];

// export const NorthernRegionAffiliates: RouteInfo[] = [
//   {
//     text: 'Conectando Latinos ',
//     text2: 'Latino Tax Professionals',
//     text3: 'San Francisco African American Chamber of Commerce',
//     text4: 'Latino Committee/San Mateo Chamber',
//     text5: 'San Francisco Filipino American Chamber of Commerce',
//     text6: 'Oakland African American Chamber of Commerce',
//     text7: 'Gilroy Chamber of Commerce',
//     text8: 'Silicon Valley Black Chamber of Commerce',
//     text9: 'Latin Business Foundation of Silicon Valley',
//     text10: 'Negozee',
//     text11: 'Greater Concord Chamber of Commerce',
//     text12: 'Livermore Valley Chamber of Commerce',
//     text13: 'Bay Area Salvadoran American Chambers of Commerce',
//     text14: 'Camara De Comercio Agrupación Del Norte De California',
//     text15: 'Guatemalan American Chamber of Commerce',
//     text16: 'Hispanic Chamber of Commerce of Contra Costa County',
//     text17: 'Hispanic Chamber of Commerce of Marin',
//     text18: 'Hispanic Chamber of Commerce Silicon Valley',
//     text19: 'Hispanic Chamber of Commerce Sonoma County',
//     text20: 'Hispanic Chambers of Commerce San Francisco',
//     text21: 'Latin American & Caribbean Business Chamber of Commerce',
//     text22: 'Napa County Hispanic Chamber of Commerce',
//     text23: 'Nicaraguan American Chamber of Commerce Northern California',
//     text24: 'Oakland Latino Chamber of Commerce',
//     text25: 'Solano Hispanic Chamber of Commerce',
//   },
// ];

@Component({
    selector: 'app-chamber-members',
    templateUrl: './chamber-members.component.html',
    styleUrls: ['./chamber-members.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChamberMembersComponent implements OnInit {
  mainTitle = 'Chamber Members';
  rowOne: any = [];
  // rowTwo: any = [];
  rowThree: any = [];
  // rowFour: any = [];
  rowFive: any = [];
  // rowSix: any = [];
  rowSeven: any = [];
  // rowEight: any = [];

  constructor() {}

  ngOnInit(): void {
    this.rowOne = SouthernRegion.filter((row) => row);
    // this.rowTwo = SouthernRegionAffiliates.filter((row) => row);
    this.rowThree = InlandEmpireRegion.filter((row) => row);
    // this.rowFour = InlandEmpireRegionAffiliates.filter((row) => row);
    this.rowFive = CentralRegion.filter((row) => row);
    // this.rowSix = CentralRegionAffiliates.filter((row) => row);
    this.rowSeven = NorthernRegion.filter((row) => row);
    // this.rowEight = NorthernRegionAffiliates.filter((row) => row);
  }
}
